'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducers = require('../utils/reducers');

var getInitialState = function getInitialState() {
  return {
    validUserField: (0, _reducers.getFetchSubState)('initial'),
    requestRegister: (0, _reducers.getFetchSubState)('initial'),
    register: (0, _reducers.getFetchSubState)('initial'),
    login: (0, _reducers.getFetchSubState)('initial'),
    logout: (0, _reducers.getFetchSubState)('initial')
  };
};
var initialState = getInitialState();

var actionsMap = _extends({
  resetFetchSubState: function resetFetchSubState(state /*, action*/) {
    return _extends({}, state, getInitialState());
  }
}, (0, _reducers.fetchReducer)('requestRegister', { resultName: true }), (0, _reducers.fetchReducer)('register', { resultName: true }), (0, _reducers.fetchReducer)('login'), (0, _reducers.fetchReducer)('logout'), (0, _reducers.fetchReducer)('validUserField'), (0, _reducers.fetchReducer)('isLogin'));

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var reduceFn = actionsMap[action.type];
  if (!reduceFn) return state;
  return reduceFn(state, action);
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/reducers/user.js
// module id = 519
// module chunks = 1